import { render, staticRenderFns } from "./series_model.vue?vue&type=template&id=8e93c96e&"
import script from "./series_model.vue?vue&type=script&lang=js&"
export * from "./series_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports